import { useStore as _useStore } from 'react-redux';

export default _useStore.withTypes();
